import { render, staticRenderFns } from "./bus_info.vue?vue&type=template&id=23c746cc&scoped=true&"
import script from "./bus_info.vue?vue&type=script&lang=js&"
export * from "./bus_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c746cc",
  null
  
)

export default component.exports